<template>
  <div>
    <app-header />
    <!--banner-->
    <section class="banner-wrap">
      <div id="earth"></div>
      <div class="container banner textC">
        <div class="Apictxt"></div>
      </div>
    </section>
    <section class="cont1">
      <h3>公司介绍</h3>

      <div class="about-txt" style="text-indent: 2em;">
        <!-- <p>医学生物特征计算是指通过研究疾病和健康状况对人体的生理特征（如人脸、青筋、鼻子、耳朵、痘痘、趾甲、指纹、手形、舌头等）和行为特征（如形态、气味、颜色、声音、噩梦、口味等）等生物特征的影响，利用异常信号、图像处理、模式识别和大数据技术建立起的基于生物特征计算智能诊断模型。</p>
        <p>医学生物特征计算一般包括数据采集与预处理、病理特征提取、诊断分析等几个模块。由于医学生物特征计算关注的是病理特征的量化分析和诊断，所以医学生物特征计算中的数据采集模块更关注环境的标准化和稳定性。至于特征提取和诊断分析模块往往需要借鉴相关诊断理论和专家知识来实现。</p>
        <p>传统中医诊断往往过于依赖医生的个人经验，在一定环境上存在诊断结果可重现性不强和主观性的问题。因而在保持中医诊断自身优势基础上，只有发展医学生物特征计算技术，才能够实现中医诊断的客观化和标准化以及智能化。</p> -->
        <p>吾征AI是大健康智能认知生活主流品牌，是中润普达旗下智能认知健康管理实体。我们通过人工智能（AI）中文语义计算、图像识别、物联网、智能硬件、云服务和机器人等技术，努力为用户感知自我、认识自我以及自我诊断、自我管理打造一个智能化的医学生物特征认知计算和健康管理平台，让人们在大数据、物联网、人工智能中文语义识别技术营造的精准、便捷和绿色的环境里，享受高科技带来的轻松、舒适和愉悦的生活。</p>
        <p>吾征医学生物特征认知计算系统主要致力于研究和开发人体多模态生物特征（主要包括人的体相、形态等生物特征）的融合认知计算技术。吾征AI的创新之处在于对人体生物特征认知识别计算的四种关键技术实现了深入研究和突破：</p>
        <p>（一）、面向人体医学生物特征领域实际应用的小样本特征的预处理、特征提取和分类技术和方法；</p>
        <p>（二）、基于人体医学生物特征认知计算的多模态选择及多层次融合技术；</p>
        <p>（三）、完成了人体医学生物特征图像卷积、文本分类和语义提取、语义计算模型以及自学习算法和架构； </p>
        <p>（四）、能够针对不同的人体医学生物特征应用场景，进行科学的生物特征认知诊断系统规划和设计。</p>
        <p class="ab-tit">发展历程：</p>
        <!-- <p>吾征AI致力于改变传统的中医问诊模式。平台利用互联网5G技术和独立自主开发的医学生物特征认知计算模型以及侏罗纪认知芯片，将我们周围人的医学生物特征和各种健康终端设备连接起来，并赋予认知计算和智能识别的能力，从“衣食住行、望闻问切”为客户提供全方位的健康诊疗服务。</p> -->
        <!-- <p>吾征医学生物特征认知计算系统历经5年，先后研发处理了超过100亿条人体医学生物特征语义识别知识库；实现了超过2000种医学生物特征与近万种疾病病理的认知诊断算法测试，开创了国际国内认知智能的场景化应用先河；建立了300多个人体体相、生理、病理、症状等异常信号认知计算识别模型，能够助力医学生物特征认知智能（包括图像）的精准识别；系统可以通过自我学习，不断“倒逼”机器把矩阵知识联系形成一个完整的认知计算“检索链”。</p> -->
        <!-- <p>吾征医学生物特征认知计算系统产品主要基于吾征AI系统前端智能诊断、中端智能认知分析、后端以解决方案为导向，满足用户各种健康诉求，可以为用户提供智能化“望、闻、问、切”以及个性化、精准解决方案。</p> -->
        <div class="ab-main">
          <p class="ab-maint">1、吾征医学生物特征认知计算系统技术优势</p>
          <p>（一）、医学生物特征知识库：5年研发过程中处理了超过100亿条人体医学生物特征认知语义识别知识库。</p>
          <p>（二）、医学生物特征认知计算算法：5年来实现超过2000种人体的生理特征（如人脸、人耳、指纹、手形、舌形等）和行为特征（如形态、气味、颜色、声音等）等生物特征对应的疾病病理的认知计算算法，开创国际国内医学生物特征认知计算场景化应用先河；</p>
          <p>（三）、开创性构建人体异常信号识别模型：包括鼻子、人中、耳朵、手掌、手背、脸型等在内的300多个人体体相、生理、病理、症状等异常信号识别模型，能够助力医学生物特征认知智能（包括图像）的精准识别；</p>
          <p>（四）、能够快速实现医学生物特征认知计算发明专利推出：研发出快速实现医学生物特征认知计算发明原理和方法，并实现多项发明专利，奠定医学生物特征领域人工智能技术领先能力。目前已经拥有原创发明授权专利2项。其中近150多项原创发明已经被国家专利局受理或者正在受理之中；有近10项已经进入实质审查阶段；软件著作权约100项次。</p>
          <p class="ab-maint">2、吾征医学生物特征认知计算发展方向</p>
          <p>基于高新技术进行自主研发，在小信号采集处理、嵌入式硬件、人工智能语义算法和模型架构、云数据处理等方面的技术积累，目前基本解决了医学生物特征认知计算技术里面语义算法和模型架构问题以及微弱信号采集中的各种噪声干扰问；以高集成能力的嵌入式算
            法分析技术，研发出了在微小计算资源上实现复杂算法的超小体积和超低功耗的嵌入式模块。公司开发的智能芯片，由自然语言中的语义算法和模型与高整合度模组及相关配套软件所构成，是迄今为止最完整的医学生物特征认知智能解决方案。同时我们以“硬件+云服务”的模式搭建了具备数据处理分析的云端超大数据库平台，利用奈米、光学、人工智能、区块链（Blockchain）认证和边缘运算（Edge CompuTIng）等技术的进步，以实时存取（Access）和分析分子数据。不仅可以自动同步用户的参数，其先进的算法还将对此进行分析等。此外，云端数据库实时或者定期将分析报告结果发给用户或者专业人员，给出诊断或康复（维修）建议。</p>
          <p>目前主要业务将继续以算法和芯片研发作为核心，面向B端硬件提供“认知计算+芯片+传感器”的模组以及云端的支持。除了基础科研研究，公司正在积极推进健康产业智能认知技术的产业化应用，目前已投入市场30余款物联网智能认知产品，配合云平台使用可有效解决慢性病管理、精准医疗、智慧医疗、辅助诊断等众多应用场景问题。同时，公司拥有专业团队，积极推进健康产业物联网智能认知产品及云平台在其他应用场景的应用，促进产业升级。</p>
        </div>
      </div>
      <ul>
        <li>
          <em>百亿条</em>
          <span>健康智能认知语义识别知识库</span>
          <i class="zicon-1"></i>
          <p>5年研发中处理了超过100亿条人体健康认知语义识别知识库。</p>
        </li>
        <li>
          <em>2000种</em>
          <span>AI认知智能语义算法</span>
          <i class="zicon-2"></i>
          <p>5年来实现超过2000种疾病的认知智能语义算法，开创国际国内认知智能的场景化应用先河。</p>
        </li>
        <li>
          <em>300类</em>
          <span>开创性构建人体异常信号识别模型</span>
          <i class="zicon-3"></i>
          <p>包括鼻子、人中、耳朵、手掌、手背、脸型等在内的300多个人体体相、生理、病理、症状等异常信号识别模型，助力疾病认知智能的精准预警和预测。</p>
        </li>
        <li>
          <em>24小时</em>
          <span>快速实现智能认知的发明专利</span>
          <i class="zicon-4"></i>
          <p>研发出快速实现中文语义智能认知和维度的发明原理和方法，并实现多项发明专利，奠定人工智能语义识别领域的技术领先能力。</p>
        </li>
      </ul>
    </section>
    <app-footer />
  </div>
</template>

<script>
import header from '@/components/header'
import footer from '@/components/footer'

export default {
  data () {
    return {

    }
  },
  mounted () {


  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
}
</script>

<style>
@import "../assets/css/about-us.css";
.banner-wrap {
  margin-top: 0 !important;
}
.about-txt p {
  text-align: left;
  line-height: 34px;
  font-size: 16px;
}
.about-txt .ab-tit {
  font-weight: 700;
  color: #000;
  padding: 10px 0;
  text-indent: 0;
}
.about-txt .ab-main {
  padding-left: 32px;
}
.about-txt .ab-maint {
  font-weight: 700;
  text-indent: 0;
}
.Apictxt {
  width: 1032px;
  height: 160px;
  margin: 0 auto;
  background: url(../assets/images/about_Picturetext.png) no-repeat center
    bottom;
  margin-top: 230px;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue